import {
  Component,
  ComponentInterface,
  ComponentWillLoad,
  Element,
  h,
  Prop,
  VNode,
} from "@stencil/core"
import { MonetaryAmount } from "../../service-sellalong/service-sellalong"
import * as Events from "../../events/events"
import * as Theme from "../../theme/theme"

@Component({
  tag: "sellalong-discount-display",
  scoped: true,
  styleUrls: {
    theme_8629350: "./sellalong-discount-display-theme-sirplus.css",
    theme_27219324: "./sellalong-discount-display.css",
    theme_53156151463: "./sellalong-discount-display.css",
  },
})
export class DiscountDisplay implements ComponentInterface, ComponentWillLoad {
  @Element()
  element!: HTMLElement

  private theme!: Theme.Theme

  /**
   * Current sellalong discount amount applied to the cart
   */
  @Prop()
  discountAmount: MonetaryAmount | null = null

  /**
   * Current total price of cart
   */
  @Prop()
  cartTotal: MonetaryAmount | null = null

  /**
   * Current cart total after discount is applied
   */
  @Prop()
  cartTotalAfterDiscount: MonetaryAmount | null = null

  async componentWillLoad() {
    this.theme = await Theme.loadTheme(this.element)()
  }

  disconnectedCallback() {
    Events.publish({ kind: "sellalongComponentRemovedInternal" })
  }

  render() {
    const { settings, text } = this.theme
    const { discountAmount, cartTotal, cartTotalAfterDiscount } = this
    const formatCurrency = text("formatCurrency")

    const displayText: VNode =
      cartTotal && discountAmount && discountAmount.value > 0 ? (
        <span class="sellalong-discount">{formatCurrency(cartTotal)}</span>
      ) : null

    const totalText =
      cartTotalAfterDiscount !== null
        ? formatCurrency(cartTotalAfterDiscount)
        : cartTotal !== null
        ? formatCurrency(cartTotal)
        : null

    if (totalText === null) {
      return null
    }

    const children: VNode[] = [
      text("discountDisplayTitle") + ": ",
      displayText,
      <span class="sellalong-money">{totalText}</span>,
    ]

    // Dynamically create discount element from `settings.discountDisplayElement`
    return h(
      settings.discountDisplayElement,
      { class: { subtotal: true } },
      children
    )
  }
}
